"use client"

import { useEffect } from "react"
import { terapkanMigrasiDomain } from "@/modules/transaksi/client/ownership-storage"

export function MigrasiDomainReceiver() {
  useEffect(() => {
    terapkanMigrasiDomain()
  }, [])

  return null
}
